export const NavigationOverlay = () => {
    const headerItemParents = document.querySelectorAll('.header__item--parent');
    const popupSearchBg = document.querySelector('.popup-search__bg');

    headerItemParents.forEach(headerItemParent => {
      headerItemParent.addEventListener('mouseover', function(){
        popupSearchBg.classList.add('popup-search__bg--active');


      });

      headerItemParent.addEventListener('mouseout', function(){
        popupSearchBg.classList.remove('popup-search__bg--active');
      });
    });
}
